// The page the user lands on after opening the app and without a session
export const FirstRunPage = 'LoginPage';

// The main page the user will see as they use the app over a long period of time.
// Change this if not using tabs
export const MainPage = 'TabsPage';

// The initial root pages for our tabs (remove if not using tabs)
export const Tab1Root = 'PedidoPage';
export const Tab2Root = 'ClientePage';
export const Tab3Root = 'ProdutoPage';
export const Tab4Root = 'SettingsPage';



// WEBPACK FOOTER //
// ./src/pages/index.ts